import { useEffect, useState } from "react";
import { api } from "../App";

/* useCmsContent(section, defaults?)
 * --------------------------------
 * Tiny hook that fetches `/api/cms/content/:section` and merges it with the
 * local default object (so partial admin saves don't blank out untouched
 * fields). Returns `{ content, loading }`. Pure read — write happens through
 * the admin UI.
 */
export default function useCmsContent(section, defaults = {}) {
  const [content, setContent] = useState(defaults);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const t = setTimeout(() => {
      api.get(`/cms/content/${section}`)
        .then(({ data }) => {
          if (cancelled) return;
          setContent({ ...defaults, ...(data.data || {}) });
        })
        .catch(() => { /* keep defaults */ })
        .finally(() => { if (!cancelled) setLoading(false); });
    }, 0);
    return () => { cancelled = true; clearTimeout(t); };
    // We intentionally don't depend on `defaults` (caller passes a literal
    // each render) — section change is the only meaningful trigger.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section]);

  return { content, loading };
}
